import { gql } from '@apollo/client';

const UPDATE_PASSENGER_SEATS = (isNewBookingOrOnHold) => {
  const mutation = isNewBookingOrOnHold ? 'provisionallyUpdateSeat' : 'updateSeat';

  return gql`
    mutation ${mutation}($reference: String!, $seats: [InputSeats]) {
      ${mutation}(reference: $reference, seats: $seats) {
        reference

        outbound {
          id
          seats {
            coach
            number
            itemRef
          }
          serviceType {
            code
          }
        }

        eurostarOutbound @client {
          id
          seats {
            coach
            number
            itemRef
          }
        }

        greenspeedOutbound @client {
          id
          seats {
            coach
            number
            itemRef
          }
        }

        inbound {
          id
          seats {
            coach
            number
            itemRef
          }
          serviceType {
            code
          }
        }

        eurostarInbound @client {
          id
          seats {
            coach
            number
            itemRef
          }
        }

        greenspeedInbound @client {
          id
          seats {
            coach
            number
            itemRef
          }
        }
      }
    }
  `;
};

export default UPDATE_PASSENGER_SEATS;
